<template>
  <div class="main_box">
    <div class="main_bar" v-if="false">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a href="javascript:void(0)" @click="goBack()"> 投票列表 </a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <span class="currentSpan">
            {{ formTitle }}
          </span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="vote_step_box" v-show="!isFullScreen">
      <el-row :gutter="15">
        <el-col :span="6">
          <div class="check_success_box" v-if="basicCheck.IsComplete">
            <i class="el-icon-check"></i> 已完成
          </div>
          <div class="check_warning_box" v-if="!basicCheck.IsComplete">
            <i class="el-icon-close"></i>
            {{
              basicCheck.NoCompleteMessages == ''
                ? '基本信息不完善'
                : basicCheck.NoCompleteMessages
            }}
          </div>
          <a
            :class="{
              vote_step_item_active: isActive === 1,
              vote_step_item: isActive !== 1
            }"
            @click="stepClick(1)"
          >
            <!-- <i
              class="iconfont icon-choice vote_step_icon"
              v-if="basicCheck.IsComplete"
            ></i> -->
            <span class="vote_step_num hidden-sm-and-down">1.</span>
            <div class="vote_step_content">
              <div class="vote_step_title">基本信息</div>
              <div class="vote_step_desc hidden-sm-and-down">
                投票标题、类型、规则
              </div>
            </div>
          </a>
        </el-col>
        <el-col
          :span="6"
          v-if="voteInfo.MeetingVerify !== 1 && voteInfo.VoteType !== 5"
        >
          <div class="check_success_box" v-if="userCheck.IsComplete">
            <i class="el-icon-check"></i> 已选评委
          </div>
          <div class="check_warning_box" v-if="!userCheck.IsComplete">
            <i class="el-icon-close"></i>
            {{
              userCheck.NoCompleteMessages == ''
                ? '未选投票人'
                : userCheck.NoCompleteMessages
            }}
          </div>
          <a
            :class="{
              vote_step_item_active: isActive === 2,
              vote_step_item: isActive !== 2
            }"
            @click="stepClick(2)"
          >
            <!-- <i
              class="iconfont icon-choice vote_step_icon"
              v-if="userCheck.IsComplete"
            ></i> -->
            <span class="vote_step_num hidden-sm-and-down">2.</span>
            <!-- <i class="iconfont icon-pingweiguanli vote_step_icon"></i> -->
            <div class="vote_step_content">
              <div class="vote_step_title">投票人员</div>
              <div class="vote_step_desc hidden-sm-and-down">管理投票人员</div>
            </div>
          </a>
        </el-col>
        <el-col :span="6" v-if="voteInfo.VoteType !== 5">
          <div class="check_success_box" v-if="projectCheck.IsComplete">
            <i class="el-icon-check"></i> 已选项目
          </div>
          <div class="check_warning_box" v-if="!projectCheck.IsComplete">
            <i class="el-icon-close"></i>
            {{
              projectCheck.NoCompleteMessages == ''
                ? '未选待评项'
                : projectCheck.NoCompleteMessages
            }}
          </div>
          <a
            :class="{
              vote_step_item_active: isActive === 3,
              vote_step_item: isActive !== 3
            }"
            @click="stepClick(3)"
          >
            <!-- <i
              class="iconfont icon-choice vote_step_icon"
              v-if="projectCheck.IsComplete"
            ></i> -->
            <span
              class="vote_step_num hidden-sm-and-down"
              v-if="voteInfo.MeetingVerify !== 1"
            >
              3.
            </span>
            <span
              class="vote_step_num hidden-sm-and-down"
              v-if="voteInfo.MeetingVerify === 1"
            >
              2.
            </span>
            <!-- <i class="iconfont icon-zu vote_step_icon"></i> -->
            <div class="vote_step_content">
              <div class="vote_step_title">待评项目</div>
              <div class="vote_step_desc hidden-sm-and-down">管理待评项目</div>
            </div>
          </a>
        </el-col>
        <el-col
          :span="6"
          v-if="voteInfo.MeetingVerify !== 1 && voteInfo.VoteType === 5"
        >
          <div class="check_success_box" v-if="qaUserCheck.IsComplete">
            <i class="el-icon-check"></i> 已选评委
          </div>
          <div class="check_warning_box" v-if="!qaUserCheck.IsComplete">
            <i class="el-icon-close"></i>
            {{
              qaUserCheck.NoCompleteMessages == ''
                ? '未选投票人'
                : qaUserCheck.NoCompleteMessages
            }}
          </div>
          <a
            :class="{
              vote_step_item_active: isActive === 4,
              vote_step_item: isActive !== 4
            }"
            @click="stepClick(4)"
          >
            <span class="vote_step_num hidden-sm-and-down">2.</span>
            <div class="vote_step_content">
              <div class="vote_step_title">投票人员</div>
              <div class="vote_step_desc hidden-sm-and-down">管理投票人员</div>
            </div>
          </a>
        </el-col>
        <el-col :span="6" v-if="voteInfo.VoteType === 5">
          <div class="check_success_box" v-if="bodyCheck.IsComplete">
            <i class="el-icon-check"></i> 已添加题目
          </div>
          <div class="check_warning_box" v-if="!bodyCheck.IsComplete">
            <i class="el-icon-close"></i>
            {{
              bodyCheck.NoCompleteMessages == ''
                ? '未添加题目'
                : bodyCheck.NoCompleteMessages
            }}
          </div>
          <a
            :class="{
              vote_step_item_active: isActive === 5,
              vote_step_item: isActive !== 5
            }"
            @click="stepClick(5)"
          >
            <span
              class="vote_step_num hidden-sm-and-down"
              v-if="voteInfo.MeetingVerify !== 1"
            >
              3.
            </span>
            <span
              class="vote_step_num hidden-sm-and-down"
              v-if="voteInfo.MeetingVerify === 1"
            >
              2.
            </span>
            <div class="vote_step_content">
              <div class="vote_step_title">题目段落</div>
              <div class="vote_step_desc hidden-sm-and-down">管理题目段落</div>
            </div>
          </a>
        </el-col>
        <el-col :span="6">
          <el-button
            type="primary"
            style="width: 80px; height: 70px; margin-top: 16px"
            :disabled="!isComplete"
            v-if="voteInfo.Status === 0"
            @click="startVote()"
          >
            开始投票
          </el-button>
          <a
            :class="{
              vote_step_item: isActive === 4,
              vote_step_item_active: isActive != 4
            }"
            @click="stepClick(99)"
            v-if="false"
          >
            <span class="vote_step_num">4.</span>
            <!-- <i class="el-icon-setting vote_step_icon"></i> -->
            <div class="vote_step_content">
              <div class="vote_step_title">其它设置</div>
              <div class="vote_step_desc">设置细节规则</div>
            </div>
          </a>
        </el-col>
      </el-row>
    </div>
    <router-view
      :voteInfo="voteInfo"
      :meetingInfo="meetingInfo"
      :questionnaireInfo="questionnaireInfo"
    />
  </div>
</template>

<script>
import voteManageApi from '../../../api/vote/voteManage'
import questionnaireApi from '../../../api/wj/questionnaire'
export default {
  data () {
    return {
      formTitle: '新增投票',
      isActive: 1,
      basicCheck: {
        IsComplete: false,
        NoCompleteMessages: '基本信息不完善'
      },
      userCheck: {
        IsComplete: false,
        NoCompleteMessages: '未选投票人'
      },
      projectCheck: {
        IsComplete: false,
        NoCompleteMessages: '未选待评项'
      },
      qaUserCheck: {
        IsComplete: false,
        NoCompleteMessages: '未选投票人'
      },
      bodyCheck: {
        IsComplete: false,
        NoCompleteMessages: '未添加填选信息'
      },
      isComplete: false,
      voteInfo: {
        Status: null,
        MeetingVerify: 1
      },
      questionnaireInfo: {
        State: null,
        MeetingVerify: 1
      },
      isFullScreen: false
    }
  },
  provide () {
    return {
      voteCheck: this.voteCheck,
      getVoteInfo: this.getVoteInfo,
      getQuestionnaireInfo: this.getQuestionnaireInfo,
      routeChange: this.routeChange,
      switchFullScreen: this.switchFullScreen
    }
  },
  inject: ['homeSwitchFullScreen'],
  props: ['meetingInfo'],
  methods: {
    goBack: function () {
      this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
    },
    stepClick: function (step) {
      const _this = this
      _this.isActive = step
      let qid = '0'
      if (_this.$route.params.qid) {
        qid = _this.$route.params.qid
      }
      switch (step) {
        case 1:
          if (this.$route.name.indexOf('create') !== -1) {
            _this.$router.push({ name: 'createVoteBasic', params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid, qid: qid } })
          } else {
            _this.$router.push({ name: 'editVoteBasic', params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid, qid: qid } })
          }
          break
        case 2:
          if (_this.$route.params.vid && _this.$route.params.vid !== '0') {
            if (this.$route.name.indexOf('create') !== -1) {
              _this.$router.push({ name: 'createVoteUser', params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid, qid: qid } })
            } else {
              _this.$router.push({ name: 'editVoteUser', params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid, qid: qid } })
            }
          } else {
            _this.isActive = 1
            _this.$message({
              showClose: true,
              type: 'warning',
              message: '请先完善投票基本信息',
              customClass: 'custom_message'
            })
          }
          break
        case 3:
          if (_this.$route.params.vid && _this.$route.params.vid !== '0') {
            voteManageApi.getVoteDetail({
              voteId: _this.$route.params.vid
            }).then(data => {
              _this.voteInfo = data
              if (this.$route.name.indexOf('create') !== -1) {
                _this.$router.push({ name: 'createVoteProject', params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid, qid: qid } })
              } else {
                _this.$router.push({ name: 'editVoteProject', params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid, qid: qid } })
              }
            }).catch(err => {
              return err
            })
          } else {
            _this.isActive = 1
            _this.$message({
              showClose: true,
              type: 'warning',
              message: '请先完善投票基本信息',
              customClass: 'custom_message'
            })
          }
          break
        case 4:
          if (_this.$route.params.vid && _this.$route.params.vid !== '0') {
            if (this.$route.name.indexOf('create') !== -1) {
              _this.$router.push({ name: 'createVoteQAUser', params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid, qid: qid } })
            } else {
              _this.$router.push({ name: 'editVoteQAUser', params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid, qid: qid } })
            }
          } else {
            _this.isActive = 1
            _this.$message({
              showClose: true,
              type: 'warning',
              message: '请先完善投票基本信息',
              customClass: 'custom_message'
            })
          }
          break
        case 5:
          if (_this.$route.params.vid && _this.$route.params.vid !== '0') {
            if (this.$route.name.indexOf('create') !== -1) {
              _this.$router.push({ name: 'createVoteBody', params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid, qid: qid } })
            } else {
              _this.$router.push({ name: 'editVoteBody', params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid, qid: qid } })
            }
          } else {
            _this.isActive = 1
            _this.$message({
              showClose: true,
              type: 'warning',
              message: '请先完善投票基本信息',
              customClass: 'custom_message'
            })
          }
          break
        case 99:
          if (_this.$route.params.vid && _this.$route.params.vid !== '0') {
            _this.$router.push({ name: 'editVoteSetting', params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid } })
          } else {
            _this.isActive = 1
            _this.$message({
              showClose: true,
              type: 'warning',
              message: '请先完善投票基本信息',
              customClass: 'custom_message'
            })
          }
          break
      }
    },
    routeChange () {
      switch (this.$route.name) {
        case 'editVoteBasic':
          this.isActive = 1
          break
        case 'editVoteProject':
          this.isActive = 3
          break
        case 'editVoteUser':
          this.isActive = 2
          break
        case 'editVoteQAUser':
          this.isActive = 4
          break
        case 'editVoteBody':
          this.isActive = 5
          break
        case 'editVoteSetting':
          this.isActive = 99
          break
        case 'createVoteBasic':
          this.isActive = 1
          break
        case 'createVoteProject':
          this.isActive = 3
          break
        case 'createVoteUser':
          this.isActive = 2
          break
        case 'createVoteQAUser':
          this.isActive = 4
          break
        case 'createVoteBody':
          this.isActive = 5
          break
        case 'createVoteSetting':
          this.isActive = 99
          break
      }
      this.stepClick(this.isActive)
    },
    voteCheck: function () {
      const _this = this
      voteManageApi.checkVote({ VoteId: _this.$route.params.vid }).then(data => {
        const checkInfo = data
        checkInfo.forEach(function (item, index) {
          if (item.Step === 'basic') {
            _this.basicCheck.IsComplete = item.IsComplete
            if (!_this.basicCheck.IsComplete) {
              _this.basicCheck.NoCompleteMessages = ''
              item.NoCompleteMessages.forEach(function (mItem, mIndex) {
                _this.basicCheck.NoCompleteMessages += mItem + ' '
              })
            }
          }
          if (item.Step === 'user') {
            _this.userCheck.IsComplete = item.IsComplete
            if (!_this.userCheck.IsComplete) {
              _this.userCheck.NoCompleteMessages = ''
              item.NoCompleteMessages.forEach(function (mItem, mIndex) {
                _this.userCheck.NoCompleteMessages += mItem + ' '
              })
            }
          }
          if (item.Step === 'project') {
            _this.projectCheck.IsComplete = item.IsComplete
            if (!_this.projectCheck.IsComplete) {
              _this.projectCheck.NoCompleteMessages = ''
              item.NoCompleteMessages.forEach(function (mItem, mIndex) {
                _this.projectCheck.NoCompleteMessages += mItem + ' '
              })
            }
          }
          if (item.Step === 'qaUser') {
            _this.qaUserCheck.IsComplete = item.IsComplete
            if (!_this.qaUserCheck.IsComplete) {
              _this.qaUserCheck.NoCompleteMessages = ''
              item.NoCompleteMessages.forEach(function (mItem, mIndex) {
                _this.qaUserCheck.NoCompleteMessages += mItem + ' '
              })
            }
          }
          if (item.Step === 'body') {
            _this.bodyCheck.IsComplete = item.IsComplete
            if (!_this.bodyCheck.IsComplete) {
              _this.bodyCheck.NoCompleteMessages = ''
              item.NoCompleteMessages.forEach(function (mItem, mIndex) {
                _this.bodyCheck.NoCompleteMessages += mItem + ' '
              })
            }
          }
        })
        if (_this.basicCheck.IsComplete && _this.userCheck.IsComplete && _this.projectCheck.IsComplete && _this.qaUserCheck.IsComplete && _this.bodyCheck.IsComplete) {
          _this.isComplete = true
        } else {
          _this.isComplete = false
        }
      }).catch(err => {
        return err
      })
    },
    startVote: function () {
      const _this = this
      _this.$confirm('开始后投票信息不能修改，如有调整需重新创建投票，确认开始该投票吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading('投票启动中…')
        voteManageApi.startVote({
          VoteId: _this.$route.params.vid
        }).then(data => {
          const voteNum = data
          _this.$message({
            type: 'success',
            message: '投票启动成功！',
            customClass: 'custom_message'
          })
          voteManageApi.getVoteDetail({
            voteId: _this.$route.params.vid
          }).then(data => {
            _this.voteInfo = data
            openLoading.close()
            if (voteNum > 0) {
              _this.$router.push({
                name: 'watchVote',
                params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid, votetype: _this.voteInfo.VoteType }
              })
              // this.getVoteInfo()
            } else {
              _this.$router.push({
                name: 'voteGuidePage',
                params: { mid: _this.$route.params.mid, vid: _this.$route.params.vid, votetype: _this.voteInfo.VoteType }
              })
            }
          }).catch(err => {
            openLoading.close()
            return err
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消开始投票操作',
          customClass: 'custom_message'
        })
      })
    },
    getVoteInfo: function () {
      const _this = this
      _this.openLoading()
      if (_this.$route.params.vid !== '0') {
        voteManageApi.getVoteDetail({
          voteId: _this.$route.params.vid
        }).then(data => {
          _this.voteInfo = data
          _this.openLoading().close()
        }).catch(err => {
          _this.openLoading().close()
          return err
        })
      } else {
        _this.voteInfo.Status = 0
        _this.getMeetingVoteInfo()
        _this.openLoading().close()
      }
    },
    getMeetingVoteInfo: function () {
      const _this = this
      _this.openLoading()
      _this.$api.meetingManage.getMeetingVoteInfo({
        meetingID: _this.$route.params.mid
      }).then(data => {
        _this.voteInfo.MeetingVerify = data.Verify
        _this.openLoading().close()
      }).catch(err => {
        _this.openLoading().close()
        return err
      })
    },
    getQuestionnaireInfo: function () {
      const _this = this
      if (_this.$route.params.qid !== '0') {
        questionnaireApi.getQuestionnaireDetail({
          questionnaireId: _this.$route.params.qid
        }).then(data => {
          _this.questionnaireInfo = data
        }).catch(err => {
          return err
        })
      } else {
        _this.questionnaireInfo.State = 0
      }
    },
    switchFullScreen: function () {
      const _this = this
      _this.isFullScreen = !_this.isFullScreen
      _this.homeSwitchFullScreen()
    }
  },
  mounted () {
    // const _this = this
    // this.$root.$on('routeChange', function () {
    //   _this.routeChange()
    // })
    // this.$root.$on('voteCheck', function () {
    //   _this.voteCheck()
    // })
    // this.$root.$on('getVoteInfo', function () {
    //   _this.getVoteInfo()
    // })
  },
  created () {
    if (this.$route.params.vid === '0') {
      this.formTitle = '新增投票'
      // this.voteCheck()
    } else {
      this.formTitle = '编辑投票'
    }
    this.routeChange()
    this.getVoteInfo()
    this.getQuestionnaireInfo()
  },
  watch: {
    $route () {
      if (this.$route.name === 'createVoteBasic' && this.$route.params.vid === '0') {
        this.basicCheck = {
          IsComplete: false,
          NoCompleteMessages: '基本信息不完善'
        }
        this.userCheck = {
          IsComplete: false,
          NoCompleteMessages: '未选投票人'
        }
        this.projectCheck = {
          IsComplete: false,
          NoCompleteMessages: '未选待评项'
        }
        this.qaUserCheck = {
          IsComplete: false,
          NoCompleteMessages: '未选投票人'
        }
        this.bodyCheck = {
          IsComplete: false,
          NoCompleteMessages: '未添加填选信息'
        }
      }
    }
  }
}
</script>
<style lang="less">
.vote_step_box {
  width: 100%;
  padding: 10px 0px 15px 0px;
}
.vote_step_item {
  width: 100%;
  height: 70px;
  border-radius: 3px;
  background-color: #fff;
  color: #5e6d82;
  cursor: pointer;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
}
.vote_step_item:hover {
  opacity: 0.6;
  filter: alpha(opacity=60);
}
.vote_step_item_active {
  width: 100%;
  height: 70px;
  border-radius: 3px;
  background-color: #409eff;
  //background-color: #67c23a;
  color: #fff;
  cursor: pointer;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
}
.vote_step_item_active:hover {
  //background-color: #85ce61;
  background-color: #66b1ff;
}
.vote_step_item_complete {
  width: 100%;
  height: 82px;
  border-radius: 3px;
  background-color: #67c23a;
  color: #fff;
  cursor: pointer;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
}
.vote_step_item_complete:hover {
  background-color: #85ce61;
}
.vote_step_num {
  font-style: italic;
  font-size: 40px;
  font-weight: 900;
  padding: 0px 15px 0px 0px;
  font-family: Arial, Verdana, Sans-serif;
  letter-spacing: 8px;
}
.vote_step_icon {
  font-size: 20px;
  margin-right: 20px;
  position: absolute;
  top: 3px;
  left: 15px;
  color: #67c23a;
}
.vote_step_content {
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.vote_step_title {
  font-size: 18px;
  font-weight: 700;
}
.vote_step_desc {
  font-size: 12px;
}
.check_success_box {
  height: 16px;
  width: 120px;
  background-image: url('../../../assets/images/vote/success_tip1.png');
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 6px 6px 0px 0px;
  color: #fff;
  text-align: left;
  font-size: 8px;
  padding: 0px 5px;
  word-spacing: 3px;
}
.check_warning_box {
  height: 16px;
  width: 180px;
  background-image: url('../../../assets/images/vote/warning_tip1.png');
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 6px 6px 0px 0px;
  color: #fff;
  text-align: left;
  font-size: 8px;
  padding: 0px 5px;
  word-spacing: 3px;
}
.check_none_box {
  height: 16px;
  width: 90px;
  border-radius: 6px 6px 0px 0px;
}
</style>
